// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountTypeController from "./account_type_controller"
application.register("account-type", AccountTypeController)

import ApiTryController from "./api_try_controller"
application.register("api-try", ApiTryController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BrandPreviewController from "./brand_preview_controller"
application.register("brand-preview", BrandPreviewController)

import BreakController from "./break_controller"
application.register("break", BreakController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import CompactNavController from "./compact_nav_controller"
application.register("compact-nav", CompactNavController)

import CustomerFilterController from "./customer_filter_controller"
application.register("customer-filter", CustomerFilterController)

import DelenController from "./delen_controller"
application.register("delen", DelenController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import FormDraftController from "./form_draft_controller"
application.register("form-draft", FormDraftController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HulppaneelController from "./hulppaneel_controller"
application.register("hulppaneel", HulppaneelController)

import InstallHintController from "./install_hint_controller"
application.register("install-hint", InstallHintController)

import InvoiceSelectionController from "./invoice_selection_controller"
application.register("invoice-selection", InvoiceSelectionController)

import KeuzeknoppenController from "./keuzeknoppen_controller"
application.register("keuzeknoppen", KeuzeknoppenController)

import MaterialLineController from "./material_line_controller"
application.register("material-line", MaterialLineController)

import MaterialsController from "./materials_controller"
application.register("materials", MaterialsController)

import MaterialsFilterController from "./materials_filter_controller"
application.register("materials-filter", MaterialsFilterController)

import OnderaannemerController from "./onderaannemer_controller"
application.register("onderaannemer", OnderaannemerController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)

import ProjectFilterController from "./project_filter_controller"
application.register("project-filter", ProjectFilterController)

import PushController from "./push_controller"
application.register("push", PushController)

import RondleidingController from "./rondleiding_controller"
application.register("rondleiding", RondleidingController)

import StappenController from "./stappen_controller"
application.register("stappen", StappenController)

import TimeBlocksController from "./time_blocks_controller"
application.register("time-blocks", TimeBlocksController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import TimerLocationController from "./timer_location_controller"
application.register("timer-location", TimerLocationController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
